import { Component } from 'react';
import { useLocation } from 'react-router-dom';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

class Boundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== 'test') console.error('Route render failed', error, info);
  }

  componentDidUpdate(previousProps) {
    if (this.state.error && previousProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    return <main className="flex min-h-[70vh] items-center justify-center bg-slate-100 p-5 dark:bg-slate-900"><section role="alert" className="w-full max-w-lg rounded-2xl border border-red-200 bg-white p-7 text-center shadow-xl dark:border-red-900 dark:bg-slate-800"><ExclamationTriangleIcon className="mx-auto h-11 w-11 text-red-600" /><h1 className="mt-4 text-2xl font-bold text-slate-900 dark:text-white">This page could not be displayed</h1><p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">Your data has not been changed. Reload the page, or return to the organization dashboard and try again.</p><div className="mt-6 flex flex-col justify-center gap-2 sm:flex-row"><button type="button" onClick={() => window.location.reload()} className="rounded-xl bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white">Reload page</button><a href="/organization/dashboard" className="rounded-xl border border-slate-300 px-5 py-2.5 text-sm font-semibold text-slate-700 dark:border-slate-600 dark:text-white">Organization dashboard</a></div></section></main>;
  }
}

export default function RouteErrorBoundary({ children }) {
  const location = useLocation();
  return <Boundary resetKey={location.pathname}>{children}</Boundary>;
}
